export default __webpack_public_path__ + "static/media/logo_light.b40c82f5.svg";